import { render, staticRenderFns } from "./crosschainlist.vue?vue&type=template&id=3824da6f&"
import script from "./crosschainlist.vue?vue&type=script&lang=js&"
export * from "./crosschainlist.vue?vue&type=script&lang=js&"
import style0 from "./crosschainlist.vue?vue&type=style&index=0&id=3824da6f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports